import { GraduationCap } from 'blaze-ui/icons'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'
import { Text } from 'blaze-ui/Text/Text'
import { HELP_CENTER_URL } from 'utils/constants'
import { UnlockButton } from 'blaze-components/WriterTopBar/UnlockButton'
import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { useHeaderTheme } from 'hooks/useHeaderTheme'
import { SearchButton } from 'blaze-components/WriterTopBar/SearchButton'

export const AcademyMobileTopBar = () => {
  const theme = useHeaderTheme()

  return (
    <MobileTopBarContainer.Root data-theme={theme}>
      <MobileTopBarContainer.Left>
        <UnlockButton />
        <SearchButton />
      </MobileTopBarContainer.Left>
      <MobileTopBarContainer.Center>
        <GraduationCap color="white" />
        <Text>Blaze Academy</Text>
      </MobileTopBarContainer.Center>
      <MobileTopBarContainer.Right>
        <ButtonLink variant="ghost" to={HELP_CENTER_URL} target="_blank" rel="noreferrer">
          <Text>Help</Text>
        </ButtonLink>
      </MobileTopBarContainer.Right>
    </MobileTopBarContainer.Root>
  )
}
